var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;


//////////////////
// WEBPACK FOOTER
// ../~/_string-convert@0.2.1@string-convert/camel2hyphen.js
// module id = 1634
// module chunks = 0